<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-col gap-1">
      <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-1">
          <button @click="upgradePlanModal.openModal()"
            :class="['flex w-full items-center gap-3 rounded-md px-3 py-2 text-base text-nera-text transition-colors hover:bg-nera-light-hover', !isSidebarOpen && 'justify-center']">
            <i class="fas fa-arrow-up w-4 shrink-0"></i>
            <span v-if="isSidebarOpen">Upgrade Plan</span>
          </button>
        </div>
        <UpgradePlan ref="upgradePlanModal" />
      </div>

      <button @click="userProfileModal.openModal()"
        :class="['flex w-full items-center gap-3 rounded-md px-3 py-2 text-base text-nera-text transition-colors hover:bg-nera-light-hover', !isSidebarOpen && 'justify-center']">
        <i class="fas fa-user w-4 shrink-0"></i>
        <span v-if="isSidebarOpen">Profile</span>
        <UserProfile ref="userProfileModal" />
      </button>

      <button @click="handleGettingStarted"
        :class="['flex w-full items-center gap-3 rounded-md px-3 py-2 text-base text-nera-text transition-colors hover:bg-nera-light-hover', !isSidebarOpen && 'justify-center']">
        <i class="fas fa-link w-4 shrink-0"></i>
        <span v-if="isSidebarOpen">Getting Started</span>
      </button>

      <button @click="handleLogout"
        :class="['flex w-full items-center gap-3 rounded-md px-3 py-2 text-base text-nera-text transition-colors hover:bg-nera-light-hover', !isSidebarOpen && 'justify-center']">
        <i class="fas fa-sign-out-alt w-4 shrink-0"></i>
        <span v-if="isSidebarOpen">Sign Out</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import UpgradePlan from "./UpgradePlan.vue";
import UserProfile from "./UserProfile.vue";
import { useAuthStore } from "../stores/auth";

const authStore = useAuthStore();

const upgradePlanModal = ref(null);
const userProfileModal = ref(null);

defineProps({
  isSidebarOpen: {
    type: Boolean,
    default: false,
  },
});

const handleLogout = () => {
  if (confirm("Are you sure you want to sign out?")) {
    authStore.logout();
  }
};

const handleGettingStarted = () => {
  window.open(
    "https://marketplace.microsoft.com/en-us/product/WA200010902?tab=Overview",
    "_blank",
    "noopener,noreferrer",
  );
};
</script>
